import './Intro.css'
import { mainPageText } from '../../data/general'
import nslogo from '../../images/appiconcrop3.png'

import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

const Intro = () => {
    


  return (
    <div className='intro-cards foreground'>
        <div className='intro-statement'>
            <span className='intro-statement-header'>{mainPageText.intro.statement}</span>
            <hr className='hr' />
          
            <Swiper 
                navigation={true} 
                spaceBetween={30}
                loop={true}
                pagination={{
                    clickable: true,
                }}
                modules={[Autoplay, Navigation, Pagination]} 
                className="mySwiper"
                autoplay={{
                    delay: 10000,
                    disableOnInteraction: false,
                }}
            >
                <SwiperSlide className='intro-carousel-wrapper'><div className='intro-carousel'>{mainPageText.intro.carousel1}</div></SwiperSlide>
                <SwiperSlide><div className='intro-carousel'>{mainPageText.intro.carousel2}</div></SwiperSlide>
                <SwiperSlide><div className='intro-carousel'>{mainPageText.intro.carousel3}</div></SwiperSlide>
                <SwiperSlide><div className='intro-carousel'>{mainPageText.intro.carousel4}</div></SwiperSlide>
                <SwiperSlide><div className='intro-carousel'>{mainPageText.intro.carousel5}</div></SwiperSlide>
            </Swiper>

        </div>
        
        
        <a href="https://www.northstarproject.org" target="_blank" rel="noopener noreferrer">
            <div className='intro-callToActionButton'>
                
                <img src={nslogo} className='intro-nslogo' alt='' />    
            <div className='intro-actionLink'>{mainPageText.callToAction.actionText}</div>
            </div>
        </a>
       </div>

      
  )
}

export default Intro